import React from 'react';
import PropTypes from 'prop-types';

import { HFBlock } from 'components';
import { getLang, getImage } from 'utils/Contentful';
import * as localeMap from './locale';
import './intro-page.css';

class IntroPage extends React.PureComponent {

  constructor() {
    super();
    this.state = {
      lang: {},
      images: {kv: []}
    }
  }

  componentDidMount() {
    this.setImage();
    this.setLang(this.props.localeCode);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.localeCode !== this.props.localeCode &&
       !this.state.lang[this.props.localeCode]
    ) {
      this.setLang(this.props.localeCode);
    }
  }

  setLang = localeCode => {
    getLang(localeCode, 'Intro').then(lang => {
      this.setState({
        lang: {
          ...this.state.lang,
          [localeCode]: lang
        }
      });
    });
  }

  setImage = () => {
    getImage('Intro').then(({kv}) => {
      this.setState({
        images: {
          kv: kv.map(item =>
            item ? item.fields.file.url : ""
          )
        }
      });
    })
  }

  render () {
    let lang = localeMap[this.props.locale];
    lang = this.state.lang[this.props.localeCode];
    if(!lang) return null;
    const { images: { kv } } = this.state;
    return (
      <HFBlock
        className="intro-page"
        {...this.props}
      >
        <div className="kv" style={{backgroundImage: kv[0] ? `url(${kv[0]})` : ""}}>
          <div className="container">
            <div className="heading">{lang.heading}</div>
          </div>
        </div>
        <div className="container">
          <div className="content" dangerouslySetInnerHTML={{
            __html: lang.text
          }} />
          <div className="image-block">
            {lang.images.map(img =>
              <img src={img} key={Math.random()} alt="intro" />
            )}
          </div>
        </div>
      </HFBlock>
    );
  }
}

export default IntroPage;

IntroPage.propTypes = {
  locale: PropTypes.string,
}

IntroPage.defaultProps = {
  locale: "",
}



// WEBPACK FOOTER //
// ./src/pages/IntroPage/index.js